interface ITransferReport {
  total_count: number;
  succeeded_count: number;
  failed_count: number;
  failed: {
    id: number;
    email: string;
  }[];
}

/**
 * Статусы опроса панели отбора
 */
export enum EAdmissionSurveyStatus {
  Draft = 'draft',
  ReadyForNotifications = 'ready_for_notifications',
  ReadyForTransfer = 'ready_for_transfer',
  TransferInProgress = 'transfer_in_progress',
  TransferFinished = 'transfer_finished',
}

export interface IAdmissionSurvey {
  title: string;
  active: boolean;
  start_date: string;
  end_date: string;
  notifications_sent_at: string;
  transfer_report: Partial<ITransferReport>;
  status: EAdmissionSurveyStatus;
}

export interface IAdmissionSurveyResponse {
  data: IAdmissionSurvey;
}

export type TAdmissionSurveyPayload = Omit<IAdmissionSurvey, 'notifications_sent_at' | 'transfer_report' | 'status'>;
